var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsStaggered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 104H440C444.422 104 448 100.406 448 96S444.422 88 440 88H8C3.578 88 0 91.594 0 96S3.578 104 8 104ZM440 408H8C3.578 408 0 411.594 0 416S3.578 424 8 424H440C444.422 424 448 420.406 448 416S444.422 408 440 408ZM504 248H72C67.578 248 64 251.594 64 256S67.578 264 72 264H504C508.422 264 512 260.406 512 256S508.422 248 504 248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsStaggered);
export default __webpack_public_path__ + "static/media/bars-staggered.aaab8f2a43d515461e4c0017daaa7013.svg";
export { ForwardRef as ReactComponent };